import t from "./_getMapData.js";
var r = t;
function e(a) {
  return r(this, a).has(a);
}
var s = e;
export {
  s as default
};
//# sourceMappingURL=_mapCacheHas.js.map
